import { PixelConfig, PixelType } from 'types/interfaces/ads/RetargetingPixels';

export const EXO_DOMAIN_PLACEHOLDER = 'exo_domain';
export const PIXEL_CONFIGS: Record<PixelType, PixelConfig> = {
  registration: {
    trafficJunkyUrl:
      'https://ads.trafficjunky.net/rt?action=list&type=add&id=111vdehH443&context=HK&cookiename=1&age=43200&maxcookiecount=10',
    exoClickUrl: `https://${EXO_DOMAIN_PLACEHOLDER}/tag.php?goal=a75e7ec0f33985769dbb41663ad5dab7`,
  },
  submit: {
    trafficJunkyUrl:
      'https://ads.trafficjunky.net/rt?action=list&type=add&id=333hgYFljhoUUi&context=HK&cookiename=3&age=43200&maxcookiecount=10',
    exoClickUrl: `https://${EXO_DOMAIN_PLACEHOLDER}/tag.php?goal=24ebf30a38a5bd12f66ff299ebd259dd`,
  },
  init: {
    trafficJunkyUrl:
      'https://ads.trafficjunky.net/rt?action=list&type=add&id=444khsfgGK&context=HK&cookiename=4&age=43200&maxcookiecount=10',
    exoClickUrl: `https://${EXO_DOMAIN_PLACEHOLDER}/tag.php?goal=da2320efbd6656d383b8529d7c01bf17`,
  },
};

export const STORAGE_KEYS = {
  HIDE_PAGE_OPENED: 'HIDE_PAGE_OPENED',
  RETARGETING_PIXEL_COOLDOWN: 'NEXT_RETARGETING_PIXEL_LOAD',
} as const;

export const RETARGETING_CONFIG = {
  cooldownSeconds: 60 * 3, // 3 minutes
  minClicksRequired: 1,
  minPartnerId: 100,
} as const;
